module.exports = __webpack_public_path__ + "img/pyramid_hip_roof_one.9455d449.jpg";